import { Fragment } from "react";

import WASC from "assets/img/common/wasc.png";
import AG from "assets/img/common/uc-ag-guide.png";

export const forSchools = {
  subTitle: "Introduction to Machine Learning Course for High School Students",
  schoolText: (
    <Fragment>
      <p>
        We've partnered with over 300 departments of education, schools & school
        districts to offer our academic year-long course, Introduction to AI
        Course for High School Students, for transcript credit. This course is{" "}
        <strong>FREE</strong> to school partners and school partner students.
      </p>
      <p>
        Interested in learning how you can offer this course to your students
        for credit?
      </p>
    </Fragment>
  ),
  buttonLink: "https://airtable.com/shrKuRrP6Kv1oNnNe",
  logos: [
    { src: WASC, alt: "WASC" },
    { src: AG, alt: "University Of California A-G Guide" },
  ],
};
